import { Link } from "react-router-dom";
import { useI18n } from "../I18nContext";

export default function Terms() {
  const { lang } = useI18n();
  return (
    <div className="tb-app tb-auth-page" style={{ minHeight: "100vh", padding: "3rem 1.5rem" }}>
      <Link to="/" className="tb-app-logo" style={{ marginBottom: "1.5rem", display: "inline-block" }}>
        Traction<span>Board</span>
      </Link>
      <article style={{ maxWidth: 760, margin: "0 auto", lineHeight: 1.7 }}>
        {lang === "fr" ? <FR /> : <EN />}
        <p style={{ marginTop: "3rem" }}>
          <Link to="/" className="tb-ghost-btn" style={{ padding: "10px 20px", textDecoration: "none" }}>
            ← {lang === "fr" ? "Retour à l'accueil" : "Back home"}
          </Link>
        </p>
      </article>
    </div>
  );
}

function EN() {
  return (
    <>
      <h1 className="tb-h1" data-testid="terms-heading">Terms of Service</h1>
      <p className="tb-muted">Effective date: 2026-02-11 · Last updated: 2026-02-11</p>

      <h2 className="tb-h2">1. Acceptance of terms</h2>
      <p>By accessing or using TractionBoard (the "Service"), operated from Canada, you agree to these Terms of Service. If you do not agree, do not use the Service.</p>

      <h2 className="tb-h2">2. The Service</h2>
      <p>TractionBoard is an advisory marketplace that connects founders with advisors, service providers, fund managers and accelerators. Sessions, AI summaries, frameworks, metrics, roadmaps and payment routing are provided as-is.</p>

      <h2 className="tb-h2">3. Accounts</h2>
      <p>You are responsible for safeguarding your account credentials and for all activity under your account. Notify us at <a href="mailto:support@tractionboardai.com">support@tractionboardai.com</a> of any unauthorized use.</p>

      <h2 className="tb-h2">4. Advisor subscriptions and commissions</h2>
      <p>Advisors pay a monthly subscription (Basic $99/month or Pro $299/month). TractionBoard takes a marketplace commission of 10% (Basic) or 5% (Pro) on each paid session collected through the platform. Pricing may change with 30 days notice.</p>

      <h2 className="tb-h2">5. Founder payments</h2>
      <p>Founders pay session fees through Stripe Checkout. After the advisor submits the post-meeting form, the advisor's payout (less the platform commission) is released through Stripe Connect. Refund policies are set per advisor and stated at booking.</p>

      <h2 className="tb-h2">6. Acceptable use</h2>
      <p>You agree not to misuse the Service, including but not limited to: harassment, posting unlawful content, attempting to disrupt the Service, scraping data, or using the Service to circumvent payment to advisors outside the platform once a relationship has been established through TractionBoard.</p>

      <h2 className="tb-h2">7. Confidentiality</h2>
      <p>Information shared during a session (pre-form, post-form, transcripts, AI summary) is treated as confidential between the advisor, founder, and any explicitly invited observers. TractionBoard processes this data to provide the Service.</p>

      <h2 className="tb-h2">8. Intellectual property</h2>
      <p>You retain ownership of content you submit. You grant TractionBoard a worldwide, royalty-free license to host, process, and display your content as needed to operate the Service.</p>

      <h2 className="tb-h2">9. AI features</h2>
      <p>TractionBoard uses third-party AI providers (e.g., OpenAI) to generate session summaries. Output is provided as a starting point and should not be considered legal, financial, or professional advice. Always validate with your advisor.</p>

      <h2 className="tb-h2">10. Termination</h2>
      <p>You may close your account at any time. TractionBoard may suspend or terminate accounts that violate these Terms. Upon termination, your access ends; data retention follows applicable Canadian privacy law.</p>

      <h2 className="tb-h2">11. Disclaimers and limitation of liability</h2>
      <p>The Service is provided "as is" without warranties of any kind. To the maximum extent permitted by law, TractionBoard's liability for any claim arising out of the Service is limited to the fees paid by you in the prior 12 months.</p>

      <h2 className="tb-h2">12. Governing law</h2>
      <p>These Terms are governed by the laws of the Province of Quebec, Canada, without regard to conflict-of-law principles.</p>

      <h2 className="tb-h2">13. Changes</h2>
      <p>We may update these Terms. Material changes will be communicated by email or in-app notice at least 30 days before they take effect.</p>

      <h2 className="tb-h2">14. Contact</h2>
      <p>Questions? <a href="mailto:support@tractionboardai.com">support@tractionboardai.com</a></p>
    </>
  );
}

function FR() {
  return (
    <>
      <h1 className="tb-h1" data-testid="terms-heading">Conditions d'utilisation</h1>
      <p className="tb-muted">Date d'entrée en vigueur : 2026-02-11 · Dernière mise à jour : 2026-02-11</p>

      <h2 className="tb-h2">1. Acceptation des conditions</h2>
      <p>En accédant à TractionBoard (le « Service »), exploité depuis le Canada, vous acceptez les présentes Conditions d'utilisation. Si vous ne les acceptez pas, n'utilisez pas le Service.</p>

      <h2 className="tb-h2">2. Le Service</h2>
      <p>TractionBoard est une plateforme d'accompagnement qui met en relation des fondateurs avec des conseillers, fournisseurs de services, gestionnaires de fonds et accélérateurs. Les rencontres, résumés IA, méthodologies, métriques, feuilles de route et flux de paiement sont fournis « tels quels ».</p>

      <h2 className="tb-h2">3. Comptes</h2>
      <p>Vous êtes responsable de la confidentialité de vos identifiants et de toute activité sur votre compte. Signalez tout usage non autorisé à <a href="mailto:support@tractionboardai.com">support@tractionboardai.com</a>.</p>

      <h2 className="tb-h2">4. Abonnements et commissions conseillers</h2>
      <p>Les conseillers paient un abonnement mensuel (Basic 99 $/mois ou Pro 299 $/mois). TractionBoard prélève une commission de 10 % (Basic) ou 5 % (Pro) sur chaque rencontre payée via la plateforme. Les tarifs peuvent évoluer avec un préavis de 30 jours.</p>

      <h2 className="tb-h2">5. Paiements des fondateurs</h2>
      <p>Les fondateurs paient via Stripe Checkout. Après la soumission du formulaire post-rencontre par le conseiller, le versement (net de commission) est libéré via Stripe Connect. La politique de remboursement est fixée par chaque conseiller et indiquée à la réservation.</p>

      <h2 className="tb-h2">6. Usage acceptable</h2>
      <p>Vous vous engagez à ne pas utiliser le Service à des fins illicites, à ne pas harceler, à ne pas tenter de perturber le Service, à ne pas extraire les données et à ne pas contourner le paiement aux conseillers en dehors de la plateforme une fois la relation établie via TractionBoard.</p>

      <h2 className="tb-h2">7. Confidentialité</h2>
      <p>Les informations partagées durant une rencontre (pré-formulaire, post-formulaire, verbatims, résumé IA) sont confidentielles entre le conseiller, le fondateur et les observateurs explicitement invités. TractionBoard traite ces données pour fournir le Service.</p>

      <h2 className="tb-h2">8. Propriété intellectuelle</h2>
      <p>Vous conservez la propriété de vos contenus. Vous accordez à TractionBoard une licence mondiale, libre de redevances, pour héberger, traiter et afficher vos contenus aux fins d'exploitation du Service.</p>

      <h2 className="tb-h2">9. Fonctionnalités IA</h2>
      <p>TractionBoard utilise des fournisseurs IA tiers (ex. OpenAI) pour générer les résumés de rencontre. Les contenus produits servent de point de départ et ne constituent pas un avis juridique, financier ou professionnel. Validez toujours avec votre conseiller.</p>

      <h2 className="tb-h2">10. Résiliation</h2>
      <p>Vous pouvez fermer votre compte à tout moment. TractionBoard peut suspendre ou résilier les comptes en violation des présentes Conditions. À la résiliation, l'accès cesse ; la conservation des données respecte la loi canadienne applicable sur la vie privée.</p>

      <h2 className="tb-h2">11. Exclusions et limitation de responsabilité</h2>
      <p>Le Service est fourni « tel quel » sans garantie d'aucune sorte. Dans la mesure permise par la loi, la responsabilité de TractionBoard pour toute réclamation est limitée aux frais payés au cours des 12 derniers mois.</p>

      <h2 className="tb-h2">12. Droit applicable</h2>
      <p>Les présentes Conditions sont régies par les lois de la Province de Québec, Canada, sans égard aux règles de conflit de lois.</p>

      <h2 className="tb-h2">13. Modifications</h2>
      <p>Nous pouvons mettre à jour ces Conditions. Les changements importants seront communiqués par courriel ou avis dans l'application au moins 30 jours avant leur entrée en vigueur.</p>

      <h2 className="tb-h2">14. Contact</h2>
      <p>Des questions ? <a href="mailto:support@tractionboardai.com">support@tractionboardai.com</a></p>
    </>
  );
}
